import React, { useState, useEffect} from "react";
import { makeStyles, createMuiTheme, ThemeProvider} from "@material-ui/core/styles";
import Modal from "@material-ui/core/Modal";
import Backdrop from "@material-ui/core/Backdrop";
import Fade from "@material-ui/core/Fade";
import Grid from "@material-ui/core/Grid";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import axios from "axios";
import Autocomplete from "@material-ui/lab/Autocomplete";
import InputLabel from '@material-ui/core/InputLabel';
import InputAdornment from '@material-ui/core/InputAdornment';
import IconButton from '@material-ui/core/IconButton';
import OutlinedInput from '@material-ui/core/OutlinedInput';
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';
import MessageBox from "../../../components/MessageBox/MessageBox";
import { green } from '@material-ui/core/colors';

const useStyles = makeStyles((theme) => ({
	modal: {
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
		width: "100%",
		maxWidth: "800px",
		margin: "0 auto",
	},
	paper: {
		backgroundColor: theme.palette.background.paper,
		border: "2px solid #000",
		boxShadow: theme.shadows[5],
		padding: theme.spacing(2, 4, 3),
		width: "800px",
		maxHeight:"100%",
		overflow: "auto",
	},
	root: {
		"& .MuiTextField-root": {
			width: "100%",
		},
	},
	button: {
		textAlign: "right",
		marginTop: "30px",
		"& .MuiButton-containedPrimary": {
			marginRight: "10px",
		},
	},

	buttonMarginRight: {
		marginRight: "0.5rem",
	},
}));

export default function UpdateContentNav(props) {
	const {cn_details, showModal, mainNav} = props;
	const classes = useStyles();
	const [open, setOpen] = useState(false);
	// const [mainNav, setMainNav] = useState([]);
	const [cn_fkey, setCnFkey] = useState([]);
	const [hasline, setHasline] = useState('');
	const [description, setDescription] = useState('');
	const [name, setName] = useState('');

	const [url, setUrl] = useState('');
	const [mainNavUrl, setMainNavUrl] = useState('');

	const [btnDisabled, setBtnDisabled] = useState(true);
	const [positionIndex, setPositionIndex] = useState(null)
	const [dataReady, setDataReady] = useState(false);

	//Message Box
	const [showMsgBox, setShowMsgBox] = useState(false);
	const [msgBoxContent, setMsg] = useState("Empty");
	const [msgType, setMsgType] = useState("success");
	//Message Box EOF

	let cn_id = cn_details.cn_id;
	let _cn_fkey = cn_details.cn_fkey;

	const setFields = () => {
		// await axios.get(process.env.REACT_APP_API_URL+'get_single_content_nav', {
		// 	params:{
		// 		cn_id : cn_id
		// 	},
		// }).then(function (res) {
				setHasline(cn_details.cn_hasline);
				setDescription(cn_details.cn_description);
				setName(cn_details.cn_name);
				setUrl(cn_details.cn_url);
				setCnFkey(cn_details.cn_fkey)
				setDataReady(true);
		//   }).catch(function (error) {	
		// 	console.log(error);
		//   });
		// setHasline('');
		// setDescription('');
		// setName('');
		// setUrl('');
	};

	const handleOpen = () => {
		mainNav.some(function(entry, i) {
			if (entry.main_nav_id == _cn_fkey) {
				// console.log(entry.main_nav_id);
				// console.log(res.data.data.cn_fkey);
				console.log(i);
				setPositionIndex(i);
				return true;
			}
		});
		setOpen(true);
	};

	const handleClose = () => {
		setPositionIndex(null);
		setOpen(false);
		// setDataReady(false);
	};


	const selectMainNavProps = {
		options: mainNav,
		getOptionLabel: (option) => option.main_nav_desc,
	};


	useEffect(() => { //
		if(open){
			setFields();
		}
	}, [open]);


	useEffect(() => {
		if (url && name && description && hasline && cn_fkey) {
			setBtnDisabled(false); // re-enable
		} else {
			setBtnDisabled(true); // re-enable
		}
	}, [mainNavUrl,url,name,description,hasline,cn_fkey]);

	const saveContentNav = async (position_name, main_nav, content_nav) => {
			const formData = new FormData();
			formData.append("cn_id", cn_id);
			formData.append("cn_url", url);
			formData.append("cn_name", name);
			formData.append("cn_description", description);
			formData.append("cn_fkey", cn_fkey); 
			formData.append("cn_hasline", parseFloat(hasline)); 
	
			await axios.post(process.env.REACT_APP_API_URL+'update_content_nav', formData, {
				headers: {
					'Content-Type': 'multipart/form-data'
					}
				}).then(function(res) {
					showModal('Updated Content Navigation '+ name, 'success');
					handleClose();
				  }).catch(function (error) {
					showModal('Something went wrong '+ error.message, 'warning');
					handleClose();
				  });
	}

	const handleSubmit = (e) => {
		e.preventDefault();
		saveContentNav();
    }


	return (
		<div>
				<Button variant="contained" style={{backgroundColor: "#4caf50", color:"#fff"}} color="primary" onClick={handleOpen}>
					Edit
				</Button>	
			<Modal
				aria-labelledby="transition-modal-title"
				aria-describedby="transition-modal-description"
				className={classes.modal}
				open={open}
				onClose={handleClose}
				closeAfterTransition
				BackdropComponent={Backdrop}
				BackdropProps={{
					timeout: 500,
				}}
			>
				<Fade in={open}>

				<div className={classes.paper}>
						<MessageBox in={showMsgBox} content={msgBoxContent} type={msgType}/>
						<h4 id="transition-modal-title">Edit Content Navigation</h4>
						{open && (positionIndex != null) ? (<form onSubmit={handleSubmit} className={classes.root}>
							<Grid container spacing={2}>
								<Grid item xs={12} xl={12}> 
									<TextField id="outlined-basic" label="URL" variant="outlined"  style={{marginTop:"21px"}} placeholder="URL" fullWidth={true} inputProps={{ 'aria-label': 'URL' }} value={url} onChange={e => setUrl(e.target.value)}/>
								</Grid>	
								<Grid item xs={12} xl={12}> 
									<TextField id="outlined-basic" label="Name" variant="outlined"  placeholder="Name" fullWidth={true} inputProps={{ 'aria-label': 'Name' }} value={name} onChange={e => setName(e.target.value)}/>
								</Grid>	
								<Grid item xs={12} xl={12}> 
									<TextField id="outlined-basic" label="Description" variant="outlined"  placeholder="Description" fullWidth={true} inputProps={{ 'aria-label': 'Description' }} value={description} onChange={e => setDescription(e.target.value)}/>
								</Grid>	
								<Grid item xs={12} xl={12}> 
									<TextField id="outlined-basic" label="Hasline" type="number" variant="outlined"  placeholder="-1 or 1" fullWidth={true} inputProps={{ 'aria-label': 'Hasline' }} value={hasline} onChange={e => setHasline(e.target.value)}/>
								</Grid>	
								<Grid item xs={12} md={12} lg={12} xl={12}>
									<Autocomplete
												{...selectMainNavProps}
												id="auto-complete"
												autoComplete
												includeInputInList
												defaultValue={mainNav[positionIndex]}
												className={classes.autoComplete}
												renderInput={(params) => (
													<TextField
														{...params}
														label="Select Main Nav"
														margin="normal"
														variant="outlined"
													/>
												)}
												onChange={(event, newValue) => {
													if (!newValue == "" || !newValue == null){
														console.log(newValue);
														setCnFkey(newValue.main_nav_id);
														setMainNavUrl(newValue.main_nav_href);
													}else{
														setCnFkey(null);
														setMainNavUrl('');
													}
												}}
									/>
								</Grid>	
								{/* <Grid item xs={12} xl={12}> 
									<TextField id="outlined-basic" label="Final Url Preview" variant="outlined"  placeholder="Final Url Preview" fullWidth={true} inputProps={{ 'aria-label': 'Final Url Preview', readOnly: true }} value={mainNavUrl+url}/>
								</Grid>	 */}
							</Grid>
							<div className={classes.button}>
								<Button
									variant="contained"
									onClick={handleClose}
									className={classes.buttonMarginRight}
								>
									Close
								</Button>
								<Button type="submit" disabled={btnDisabled} variant="contained" color="primary">
									Save Content Navigation
								</Button>
							</div>
						</form>) : (<></>)}
					</div>

				</Fade>
			</Modal>
		</div>
	);
}
